import { SVGProps } from 'react'

export const MessageIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 6.875V4.25M8 9.5H8.0075M4.25 12.5V14.2516C4.25 14.6513 4.25 14.8511 4.33192 14.9537C4.40317 15.043 4.5112 15.0949 4.6254 15.0948C4.75672 15.0946 4.91275 14.9698 5.22482 14.7201L7.01391 13.2889C7.37939 12.9965 7.56213 12.8503 7.76561 12.7463C7.94615 12.6541 8.13832 12.5867 8.33691 12.5459C8.56075 12.5 8.79477 12.5 9.26281 12.5H11.15C12.4101 12.5 13.0402 12.5 13.5215 12.2548C13.9448 12.039 14.289 11.6948 14.5048 11.2715C14.75 10.7902 14.75 10.1601 14.75 8.9V4.85C14.75 3.58988 14.75 2.95982 14.5048 2.47852C14.289 2.05516 13.9448 1.71095 13.5215 1.49524C13.0402 1.25 12.4101 1.25 11.15 1.25H4.85C3.58988 1.25 2.95982 1.25 2.47852 1.49524C2.05516 1.71095 1.71095 2.05516 1.49524 2.47852C1.25 2.95982 1.25 3.58988 1.25 4.85V9.5C1.25 10.1975 1.25 10.5462 1.32667 10.8323C1.53472 11.6088 2.1412 12.2153 2.91766 12.4233C3.20378 12.5 3.55252 12.5 4.25 12.5Z"
      stroke="#364359"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
